import React from "react";
import AppSidebar from "../components/layout/AppSidebar";

const AdminLayout = ({ children }) => {
  return (
    <div className="app-bg min-h-screen flex font-body">
      {/* Sidebar — shared with AppLayout so nav order/items stay consistent */}
      <AppSidebar />

      {/* Main content area */}
      <main className="flex-1 relative lg:ml-0 min-h-screen overflow-auto">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
